<script setup lang="ts">
  import type { Article } from '../../types'
  import { useRedirectActions } from '../../composables/useRedirectActions'
  import { hasTenantHostApi } from '../../utils/host-browser-apis/hasTenantHostApi'

  export interface SiderailArticleGroupProps {
    design: 'google' | 'msn'
    type: 'related-stories' | 'top-stories'
    articles: Article[]
  }

  export type ArticleSiderailProps = {
    topGroup: SiderailArticleGroupProps | undefined
    bottomGroup: SiderailArticleGroupProps | undefined
  }

  defineProps<ArticleSiderailProps>()

  const { sendToNewsPage, navigateToSearchPage } = useRedirectActions()

  const contentDisplaySettingsStore = useContentDisplaySettingsStore()
  const { featureFlags } = storeToRefs(contentDisplaySettingsStore)

  const adSettingsStore = useAdSettingsStore()
  const { data: adSettings } = storeToRefs(adSettingsStore)

  const shouldShowSearchbox = computed(
    () =>
      featureFlags.value.enableLocalNewsSearch &&
      useRoute().name !== 'search' &&
      !hasTenantHostApi()
  )

  const adPrefix = useAppConfig().siteAdPrefix
</script>
<template>
  <div
    data-testid="article-siderail"
    class="article-siderail border-border-interaction-normal flex w-[300px] flex-col items-center justify-center gap-3 bg-inherit"
  >
    <Searchbox
      v-if="shouldShowSearchbox"
      placeholder="Find more news"
      :sticky="false"
      @press-enter-on-search-input="navigateToSearchPage"
    />
    <div
      v-if="adSettings.summaryPage?.showSiderailTopAdPlacement"
      :class="`${adPrefix}_article_siderail_top`"
      class="ad_placement rounded-6px flex h-[615px] w-[300px] items-center justify-center overflow-hidden"
    ></div>
    <ArticleGroup
      v-if="topGroup"
      v-bind="topGroup"
      :show-border="topGroup?.design === 'msn'"
      @article-click="sendToNewsPage"
    />
    <div
      v-if="adSettings.summaryPage?.showSiderailMiddleAdPlacement"
      :class="`${adPrefix}_article_siderail_middle`"
      class="ad_placement rounded-6px flex h-[615px] w-[300px] items-center justify-center overflow-hidden"
    ></div>
    <ArticleGroup
      v-if="bottomGroup"
      v-bind="bottomGroup"
      :show-border="bottomGroup?.design === 'msn'"
      @article-click="sendToNewsPage"
    />
    <div
      v-if="adSettings.summaryPage?.showSiderailBottomAdPlacement"
      :class="`${adPrefix}_article_siderail_bottom`"
      class="ad_placement"
    />
  </div>
</template>
